import { mode } from "@chakra-ui/theme-tools";
export const badgeStyles = {
  components: {
    Badge: {
      baseStyle: {
        borderRadius: "0.5rem",
        lineHeight: "100%",
        padding: "7px",
        paddingLeft: "12px",
        paddingRight: "12px",
        fontWeight: "500",
      },
      variants: {
        outline: () => ({
          borderRadius: "0.5rem",
        }),
        brand: (props) => ({
          bg: mode("brand.500", "brand.500")(props),
          color: "white",
          _focus: {
            bg: mode("brand.500", "brand.500")(props),
          },
          _active: {
            bg: mode("brand.600", "brand.600")(props),
          },
          _hover: {
            bg: mode("brand.600", "brand.400")(props),
          },
        }),
      },
    },
  },
};
